import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './router';
import { store, persistor } from './redux/store';
import 'assets/css/global.scss';
import 'assets/css/reset.scss';
import setBooheeSeeConfig from 'tools/boohee-see';

setBooheeSeeConfig();

if (
  /console=true/.test(window.location.href) ||
  localStorage.getItem('active-eruda') === 'true'
) {
  import('vconsole').then(({ default: VConsole }) => {
    new VConsole();
  });
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept(App, function() {
    console.log('Accepting the updated printMe module!');
  });
}
